import React from "react";
import TitleFormat2 from "../../../components/TitleFormat2";
import TrackRecordClientContent from "./TrackRecordClientContent";
import { useTranslation } from "react-i18next";
import { Seo } from "../../../components/Seo";

const TrackRecordClient = () => {
  const { t } = useTranslation();
  return (
    <>
      <Seo title={t("trackRecord.client.seo.title")} description={t("trackRecord.client.seo.des")} path="projects/clients" />
      <div className="track_record_client_wrap" style={{ maxWidth: "1920px", width: "100%", paddingBottom: "20%" }}>
        <TitleFormat2 text={t("trackRecord.client.title")} />
        <TrackRecordClientContent />
      </div>
    </>
  );
};

export default TrackRecordClient;
